import { compose, createStore } from 'redux';

import middleware from './middleware';
import reducer from './reducer';

export default function storeInitializer(store) {
  const enhancers = [middleware];

  if ((process.env.NODE_ENV === 'development' && window.__REDUX_DEVTOOLS_EXTENSION__)) {
    enhancers.push(window.__REDUX_DEVTOOLS_EXTENSION__());
  }

  store.injectReduxStore(createStore(reducer, compose(...enhancers)));
  store.dispatch({ type: 'APP_INIT' });
}
